import React from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ENABLED_BILLING_RECONCILIATION_PROGRAMS, PROGRAMS, SERVICE_MONTHS } from './constants.js';

const ENABLED_PROGRAMS = new Set(ENABLED_BILLING_RECONCILIATION_PROGRAMS);

const ProgramMonthBar = ({
  program,
  onProgramChange,
  serviceMonth,
  onServiceMonthChange,
  serviceMonths = SERVICE_MONTHS,
  onCreateMonth,
}) => (
  <Paper variant="outlined" sx={{ p: 2, borderRadius: 1.5 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Program</InputLabel>
        <Select
          value={program}
          label="Program"
          inputProps={{ 'aria-label': 'Program' }}
          onChange={(e) => onProgramChange(e.target.value)}
        >
          {PROGRAMS.map((p) => {
            const disabled = !ENABLED_PROGRAMS.has(p.id);
            return (
              <MenuItem key={p.id} value={p.id} disabled={disabled}>
                {p.label} {disabled && '- coming soon'}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Service month</InputLabel>
        <Select
          value={serviceMonth}
          label="Service month"
          inputProps={{ 'aria-label': 'Reconciliation month' }}
          onChange={(e) => onServiceMonthChange(e.target.value)}
        >
          {serviceMonths.map((m) => (
            <MenuItem key={m.id} value={m.id}>{m.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        size="small"
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={onCreateMonth}
        sx={{
          textTransform: 'none',
          borderStyle: 'dashed',
          color: 'text.secondary',
          borderColor: 'divider',
          '&:hover': {
            borderStyle: 'solid',
            borderColor: 'primary.main',
            color: 'primary.main',
            bgcolor: 'action.hover',
          },
        }}
      >
        New month
      </Button>
    </Stack>
  </Paper>
);

export default ProgramMonthBar;
